<template>
  <div class="c-app">
    <TheSideBar></TheSideBar>
    <CWrapper>
      <TheHeader></TheHeader>
      <loading 
        :active.sync="isLoading"
        loader="bars"
        color="#002bc6"
        background-color="#edf6fa"
      >
      </loading>
      <div class="c-body">
        <main class="c-main">
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from 'vuex';
import TheSideBar from './TheSidebar';
import TheHeader from './TheHeader';
export default {
    name: 'TheContainer',
    components: {
        Loading,
        TheHeader,
        TheSideBar
    },
    computed: mapState(['isLoading']),
    async created(){
      let listStates = Object.keys(this.$store.state);
      await listStates.forEach((state) => {
        this.$store.commit('getStorage', state);
      });
    }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
